import { useRef } from 'react'
import {
  PreviewContainer,
  PreviewImage,
  PreviewText,
  PreviewName,
  ProjectsTechnic,
} from './styled'
import { ProjectType } from '../../types'

const Preview: React.FC<{
  i: number
  project: ProjectType
}> = ({ i, project }) => {
  const ref = useRef<HTMLLIElement>(null)
  if (!project) return null
  return (
    <PreviewContainer
      ref={ref}
      layout
      initial={{ y: 20, opacity: 0 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: {
          ease: 'easeOut', //['circIn'],
          duration: 0.2,
          delay: i * 0.1,
        },
      }}
      exit={{
        y: 20,
        opacity: 0,
        transition: {
          ease: 'easeIn', //['circIn'],
          duration: 0.1,
        },
      }}
      key={project.name}
    >
      <div>
        <PreviewImage $aspectRatio={project.aspectRatio}>
          <img src={project.preview} alt={project.name} />
        </PreviewImage>
        <PreviewText>
          <PreviewName>
            <span>{project.name}</span>
            {project.year.length > 0 && <span>({project.year})</span>}
          </PreviewName>
          {project.technics.length > 0 &&
            project.technics.map((technic, index) => {
              return (
                <ProjectsTechnic key={`${technic}-${index}`}>
                  {technic}
                </ProjectsTechnic>
              )
            })}
        </PreviewText>
      </div>
      <div className="face"></div>
    </PreviewContainer>
  )
}
export default Preview
